import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-annual-multi-trip-cover',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './annual-multi-trip-cover.component.html',
  styleUrl: './annual-multi-trip-cover.component.scss',
})
export class AnnualMultiTripCoverComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Annual Multi Trip Travel Insurance | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `World2Cover annual multi trip travel insurance gives frequent travellers cover for multiple journeys. Get your policy online.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Annual Multi Trip Travel Insurance | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover annual multi trip travel insurance gives frequent travellers cover for multiple journeys. Get your policy online.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
